/**
 * Syncfusion UI Library Configuration
 * 
 * This file centralizes Syncfusion configuration and provides helper utilities
 * for using Syncfusion components throughout the application.
 * 
 * Primary UI Library: Syncfusion (ej2-react-*)
 * Secondary UI Libraries: Ant Design (antd), Bootstrap (react-bootstrap)
 */

import { registerLicense } from '@syncfusion/ej2-base';
import config from './config';

// Syncfusion License Key
const SYNCFUSION_LICENSE = config.SYNCFUSION_LICENSE;

/**
 * Initialize Syncfusion configuration
 * This should be called once at application startup
 */
export const initializeSyncfusion = () => {
  registerLicense(SYNCFUSION_LICENSE);
};

/**
 * Syncfusion theme configuration
 */
export const syncfusionTheme = {
  primary: 'bootstrap5', // Bootstrap 5 theme
  version: '32.1.22', // Matches installed package version
  rtlSupport: true, // RTL is automatically handled via CSS direction property
};

/**
 * Common Syncfusion component configurations
 */
export const syncfusionConfig = {
  // Grid component default settings
  grid: {
    allowPaging: true,
    pageSettings: { pageSize: 10 },
    allowSorting: true,
    allowFiltering: true,
    enableRtl: true, // Enable RTL for Hebrew support
  },
  
  // Calendar/DatePicker default settings
  calendar: {
    enableRtl: true,
    locale: 'he-IL', // Hebrew locale
  },
  
  // Common popup settings
  popup: {
    enableRtl: true,
  },
};

export default {
  initializeSyncfusion,
  syncfusionTheme,
  syncfusionConfig,
};

